import { HttpDataService } from '../http/http-data.service';

import { AuthService } from '../services/auth/auth.service';
import { IBasicContact, IContact } from '../../../type_definitions/datatypes';
import { Injectable } from '@angular/core';

export enum CancelIdContact {
  TO = 'CONTACTS_TO',
  CC = 'CONTACTS_CC',
  BCC = 'CONTACTS_BCC',
}

@Injectable()
export class ContactDataService {
  constructor(
    private authService:AuthService,
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getContacts = (filter:string, cancelId:CancelIdContact):Promise<IContact> => {
    return this.httpDataService.doGET(
      'rest/contacts/mailcontacts',
      { filter },
      undefined,
      undefined,
      cancelId
    );
  };

  public cancelGetContacts = (cancelId:CancelIdContact) => {
    this.httpDataService.cancelRequests(cancelId);
  };

  public NAMs(contactType?:string):Promise<IContact[]> {
    return this.httpDataService.doGET('rest/contacts/nams', { contactType: contactType }, undefined, 'Error loading '.concat(contactType));
  }

  public getAcslActiveContacts():Promise<IBasicContact[]> {
    return this.httpDataService.doGET(
      'rest/acslinfo/activeacslusers',
      {},
      undefined,
      'Error loading users'
    );
  }

  public getContactPictureUrl(contactId:number):string {
    return this.authService.authenticatedUrl(`rest/userman/userprofile/${contactId}/profilepicture`);
  }
}